import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$axios = axios.create({
  baseURL: 'https://hackverflow-server.arjunagbt.icu/'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
